import request, { METHODS } from "src/utils/api-base";

const salesOrderApis = {
  getSalesList: (params: {
    page: number;
    limit: number;
    createdBy?: string;
  }) => {
    return request({
      route: "/app/sale-order/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  createSalesOrder: (payload: any) => {
    return request({
      route: "/app/sale-order/create",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getOrderById: (orderId: string) => {
    return request({
      route: `/app/sale-order/${orderId}`,
      method: METHODS.GET,
      auth: true,
    });
  },

  updateSalesOrder: (orderId: string, payload: any) => {
    return request({
      route: `/app/sale-order/${orderId}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },
};

export default salesOrderApis;
